// 依赖注入
import Vue from 'vue';
import Vuex from 'vuex';
// 业务注入
import base from './base/index'; // 基础数据



Vue.use(Vuex);
export default new Vuex.Store({
  state: {
  },
  mutations: {},
  actions: {},
  modules: {
    ...base,
  },
});
